export default "__VITE_ASSET__jbJ8VbnV__"